import { SpeciesTaxonomyScreen } from '@/screens/SpeciesSearch/SpeciesTaxonomyScreen/SpeciesTaxonomyScreen';

export default function BoardEditReportSpeciesTaxonomyScreen(): React.ReactNode {
  return <SpeciesTaxonomyScreen />;
}
